<div class="icon-wrapper" [@leaveAnimation] *rxFor="let svg of svg$" [innerHtml]="svg"></div>